<template>
  <div>
    <div>
      <p class="f-c-midgrey f-14 remove-margin">
        Pembayaran dapat dilakukan ke salah satu rekening berikut ini
      </p>
      <div class="center-iconadd">
        <img src="@/assets/img/BCA.png" alt="" class="wid-100 p-t-24 p-d-20" />
        <p class="f-Overpass f-14 f-bold f-c-black remove-margin">1131406989</p>
        <p class="f-Overpass f-14 f-c-black remove-margin">
          Sri Martiningsih S.Pd
        </p>
      </div>

      <div class="center-iconadd">
        <img src="@/assets/img/BNI.png" alt="" class="wid-100 p-t-24 p-d-20" />
        <p class="f-Overpass f-14 f-bold f-c-black remove-margin">1800700890</p>
        <p class="f-Overpass f-14 f-c-black remove-margin">
          Sdr MAS FREDO PRIMAYUDHA
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RekeningBankPayment",
};
</script>
